// Moved out of App.js `Dashboard` (BM-007 header extraction) so the shared
// AppHeader and the Dashboard shell read ONE definition. Values unchanged.

export const BLUE_HEADER_ROLES = [
  'admin',
  'typing_processor', 'processor', 'tax_processor', 'tax_search_processor',
  'search_processor', 'title_search_processor',
  'tax_search_team_leader', 'title_search_team_leader', 'tax_team_leader',
];

// Route to view mapping
export const ROUTE_TO_VIEW = {
  '/dashboard': 'orders',
  '/dashboard/orders': 'orders',
  '/dashboard/workspace': 'my-workspace',
  '/dashboard/team': 'team-management',
  '/dashboard/reports': 'reports',
  '/dashboard/favorites': 'favorites',
  '/dashboard/processor-orders': 'processor-orders',
  '/dashboard/typing': 'typing',
  '/dashboard/leave': 'leave-management',
  '/dashboard/attendance': 'my-attendance',
  '/team/edit-requests': 'edit-requests',
  '/admin/billing': 'billing',
};

// View to route mapping (for navigation)
export const VIEW_TO_ROUTE = {
  'orders': '/dashboard',
  'my-workspace': '/dashboard/workspace',
  'team-management': '/dashboard/team',
  'reports': '/dashboard/reports',
  'favorites': '/dashboard/favorites',
  'processor-orders': '/dashboard/processor-orders',
  'typing': '/dashboard/typing',
  'leave-management': '/dashboard/workspace',
  'my-attendance': '/dashboard/workspace',
  'edit-requests': '/team/edit-requests',
  'billing': '/admin/billing',
};

// Get default route based on user role
export const getDefaultRoute = (userRole) => {
  switch (userRole) {
    case 'processor':
    case 'tax_processor':
    case 'title_search_processor':
    case 'search_processor':
      return '/dashboard/processor-orders';
    // TYPING-001 Phase 2b — Typing Processor lands on the embedded Typing queue
    case 'typing_processor':
      return '/dashboard/typing';
    // IT roles should land on IT Operations Dashboard
    case 'it_manager':
    case 'it_support':
      return '/admin/it-dashboard';
    // QC Specialists land on dedicated QC Dashboard
    case 'qc_specialist':
      return '/qc-dashboard';
    // Jurisdiction Manager lands on Jurisdiction Dashboard
    case 'jurisdiction_manager':
      return '/admin/jurisdictions/dashboard';
    // Jurisdiction Requestor (Session 24) has NO access to the operational
    // order dashboard. Route to their dedicated lightweight dashboard.
    case 'jurisdiction_requestor':
      return '/admin/my-jurisdiction-dashboard';
    // Accounting (Feb 2026) — billing-only persona.
    case 'accounting':
      return '/admin/billing';
    // HR-PERSONA-002 (Jul 2026) — HR roles land on the HR dashboard.
    case 'hr_manager':
    case 'hr_specialist':
    case 'hr':
      return '/admin/hr/dashboard';
    // CRM Phase 1 — Sales & Marketing lands on the CRM workspace.
    case 'sales_marketing':
      return '/crm';
    case 'order_desk':
    default:
      return '/dashboard';
  }
};

export const isITRole = (userRole) => userRole === 'it_manager' || userRole === 'it_support';

export const isQCSpecialistRole = (userRole) => userRole === 'qc_specialist';

// Accounting persona — billing-only. Redirected away from the
// operational order dashboard, has no Dashboard nav button.
export const isAccountingRole = (userRole) => userRole === 'accounting';

export const getRoleDisplayName = (role) => {
  switch (role) {
    case 'order_desk': return 'Order Desk';
    case 'processor': return 'Processor';
    case 'title_search_processor': return 'Title Search Processor';
    case 'search_processor': return 'Search Processor';
    case 'title_search_team_leader': return 'Title Search Team Leader';
    case 'tax_search_team_leader': return 'Tax Search Team Leader';
    case 'vendor_manager': return 'Vendor Manager';
    case 'accounts': return 'Accounts Payable';
    case 'sales_marketing': return 'Sales & Marketing';
    default: return role;
  }
};
